import { TimeRangePickerProps } from 'antd'
import { Dayjs } from 'dayjs'

import { dayjs } from '@/utils/dayjs'

function getPastMonthsDateRange(n: number) {
  const now = dayjs()
  const [h, m, s] = [now.hour(), now.minute(), now.second()]

  return Array.from({ length: n }, (_, i) => {
    const month = now.subtract(i, 'month')
    const start = month.startOf('month').hour(h).minute(m).second(s)
    const end = i === 0 ? now : month.endOf('month').hour(h).minute(m).second(s)

    return {
      label: month.format('MMMM'),
      value: [start, end],
    }
  })
}

const yesterday = dayjs().add(-1, 'day')

const mapToOption = ({ label, value }: { label: string; value: Dayjs[] }) => ({
  label,
  value: [dayjs(value[0]), dayjs(value[1])],
})

export function lastDaysOption(num: number) {
  return {
    label: `Last ${num} days`,
    value: [yesterday.add(-num + 1, 'd'), yesterday],
  }
}

export const getRangePresets = () =>
  [
    { label: 'All time', value: [dayjs('2016-07-01'), dayjs().endOf('day')] },
    {
      label: 'Custom',
      value: [yesterday.add(-1, 'month').add(1, 'day'), yesterday],
    },
    lastDaysOption(7),
    lastDaysOption(14),
    lastDaysOption(30),
    lastDaysOption(90),
    lastDaysOption(365),
    ...getPastMonthsDateRange(6),
  ].map(mapToOption)

export const getRangePresets2 = () =>
  [
    { label: 'Today', value: [dayjs(), dayjs()] },
    { label: 'Yesterday', value: [dayjs().add(-1, 'd'), dayjs().add(-1, 'd')] },
    lastDaysOption(7),
    lastDaysOption(30),
    lastDaysOption(90),
    ...getPastMonthsDateRange(6),
    {
      label: dayjs().year().toString(),
      value: [dayjs().startOf('year'), dayjs()],
    },
  ].map(mapToOption)

export default function useRangePickerOptions() {
  const maxDate = dayjs().endOf('day')
  const rangePresets1 = getRangePresets() as TimeRangePickerProps['presets']
  const rangePresets2 = getRangePresets2() as TimeRangePickerProps['presets']
  return { maxDate, rangePresets1, rangePresets2 }
}
